"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRecommendedProductFamily = void 0;
const product_1 = require("./product");
const product_family_1 = require("./product_family");
function mockRecommendedProductFamily(overrides = {}) {
    return {
        product_family: (0, product_family_1.mockProductFamily)(),
        products: [(0, product_1.mockProduct)()],
        contains_all_colors: true,
        ...overrides,
    };
}
exports.mockRecommendedProductFamily = mockRecommendedProductFamily;
